import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

import { StateService } from '@services/Logic/state.service';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import FontFaceObserver from 'fontfaceobserver';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
  @Input() newMessagesCount: number;
  @Input() profileImage: any;

  closeSidebarComponentRef: Subscription;
  defaultImage = `${environment.basePath}assets/svg/logo.svg`;

  navItems: any[];
  activeTab: number;

  fontLoaded = false;

  constructor(
    private router: Router,
    private stateService: StateService,
    private translatePipe: TranslatePipe,
  ) {}

  ngOnInit() {
    const fontObserver = new FontFaceObserver('Material Icons');
    fontObserver.load().then(() => {
      this.fontLoaded = true;
    });
    setTimeout(() => {
      this.navItems = [
        {
          id: 'pinploy-footer-1',
          icon: 'list',
          text: this.translatePipe.transform('COMPONENTS.HEADER.DASHBOARD'),
        },
        {
          id: 'pinploy-footer-0',
          icon: 'search',
          text: this.translatePipe.transform('COMPONENTS.HEADER.HOME'),
        },
        {
          id: 'pinploy-footer-2',
          icon: 'style',
          text: this.translatePipe.transform(
            'COMPONENTS.SIDEBAR.ACCOUNT.CREATE',
          ),
        },
        {
          id: 'pinploy-footer-3',
          icon: 'forum',
          text: this.translatePipe.transform('COMPONENTS.HEADER.MESSAGES'),
        },
        {
          id: 'pinploy-footer-4',
          icon: 'more_horiz',
          text: this.translatePipe.transform('COMPONENTS.HEADER.ACCOUNT'),
          profileImage: this.profileImage,
        },
      ];
    }, 100);

    this.initFooterTab();

    this.closeSidebarComponentRef =
      this.stateService.closeSidebarComponentSource.subscribe((res) => {
        this.initFooterTab();
      });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.initFooterTab();
      }
    });
  }

  ngOnDestroy() {
    this.closeSidebarComponentRef.unsubscribe();
  }

  initFooterTab() {
    const url = this.router.url.split('?')[0];
    if (url.startsWith('/opgaver/mine-opgaver')) {
      this.activeTab = 0;
    } else if (url.startsWith('/opgaver')) {
      this.activeTab = 1;
    } else if (url === '/beskeder') {
      this.activeTab = 3;
    } else if (url === '/indstillinger') {
      this.activeTab = 4;
    } else {
      this.activeTab = -1;
    }
  }

  changeTab(index: number) {
    this.activeTab = index;
    if (index === 0) {
      this.router.navigate(['/opgaver/mine-opgaver']);
    } else if (index === 1) {
      this.router.navigate(['/opgaver']);
    } else if (index === 2) {
      this.openCreateTaskDialog();
    } else if (index === 3) {
      this.router.navigate(['/beskeder']);
    } else if (index === 4) {
      this.openSidebar();
    }
  }

  openSidebar() {
    this.stateService.showSidebar(4);
  }

  hideBadge(item: any) {
    return item.icon !== 'forum' || this.newMessagesCount === 0;
  }

  openCreateTaskDialog() {
    this.router.navigate(['/opret']);
  }
}
